import ResetPasswordPage from './ResetPasswordPageContainer';

export default ResetPasswordPage;
